<template>
  <div
    class="mx-auto flex w-full flex-col items-center px-4 py-9 text-center tablet:py-16"
  >
    <IconSearch class="h-9 w-9 tablet:h-12 tablet:w-12" />
    <h2 class="my-6 text-2xl font-bold tablet:text-[40px]">
      {{ t('search-menu.no-results') }}
    </h2>
    <p class="text-sm text-gray-700 tablet:text-base">
      {{ t('search-menu.no-relevant') }}
    </p>
    <TheButton
      class="mt-9 font-bold tablet:mt-11"
      :title="t('search-menu.clear-all')"
      @click="emit('clear')"
    >
      {{ t('search-menu.clear-all') }}
    </TheButton>
  </div>
</template>

<script setup lang="ts">
  const emit = defineEmits<{ (e: 'clear'): void }>();

  const { t } = useI18n();
</script>
